module.exports = __webpack_public_path__ + "img/main-sm.af35d906.jpg";